export default "__VITE_ASSET__5Jn0yQP9__"